<template lang="html">

    <aside class="accesos">

        <article class="titulados">

          <router-link :to="$t('enlaces.titulados')" class="enlace-cover"></router-link>

          <div class="top column-center">
            <h2>Candidatos</h2>
          </div>

          <div class="bottom column-center">
            <h2>Accede al mercado laboral</h2>
          </div>

        </article>
        <article class="empresas">
          <router-link :to="$t('enlaces.empresas')" class="enlace-cover"></router-link>
          <div class="top column-center">
            <h2>Empresas</h2>
          </div>

          <div class="bottom column-center">
            <h2>Recluta el mejor talento</h2>
          </div>
        </article>
<!--         <article class="tutores">
          <router-link :to="$t('enlaces.tutores')" class="enlace-cover"></router-link>
          <div class="top column-center">
            <h2>Tutores</h2>
          </div>

          <div class="bottom column-center">
            <h2>Seguimiento a titulados en prácticas</h2>
          </div>
        </article> -->

      </aside>
  
  </template>
  
  <script lang="js">
    export default {
      name: 'accesos',
    }
  </script>



// WEBPACK FOOTER //
// src/components/parts/accesos.vue